import { Col, Form } from "antd";
import { Box, HeaderOverview } from "components";
import { LoadingDashboard } from "pages/overview";
import { useOverview } from "providers/overview";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetDashBoardComplaint } from "service/dashboard/central/recommrnt-feed-back";

export const StatusBox = () => {
  const { t } = useTranslation();
  const { property, findDate } = useOverview();

  const statusComplaintsDate = Form.useWatch("statusComplaintsDate");
  const date = findDate(statusComplaintsDate);
  const { data, isFetching } = useGetDashBoardComplaint({ property, ...date });

  const allStatus = data?.[0]?.data.find((item) => item.status === "ALL") || { category: { APPEAL: 0, SUGGEST: 0, FEEDBACK: 0 } };
  const pendingStatus = data?.[0]?.data.find((item) => item.status === "PENDING") || { category: { APPEAL: 0, SUGGEST: 0, FEEDBACK: 0 } };
  const successStatus = data?.[0]?.data.find((item) => item.status === "SUCCESS") || { category: { APPEAL: 0, SUGGEST: 0, FEEDBACK: 0 } };
  
  return (
    <React.Fragment>
      <Col md={24} lg={24} xl={24}>
        <HeaderOverview
          title={t("property.complaint", { ns: "menu" })}
          name="statusComplaintsDate"
        />
      </Col>
      <Col md={24} lg={8} xl={8}>
        <LoadingDashboard loading={isFetching}>
          <Box
            isGrid={true}
            title={t("number-complaints")}
            count={ 0}
            color="blue"
            textAfter={isFetching}
             appealTotal={allStatus.category?.APPEAL || 0}
            suggestTotal={allStatus.category?.SUGGEST || 0}
            feedbackTotal={allStatus.category?.FEEDBACK || 0}
          />
        </LoadingDashboard>
      </Col>
      <Col md={24} lg={8} xl={8}>
        <LoadingDashboard loading={isFetching}>
          <Box
            isGrid={true}
            title={t("number-pending-complaints")}
            count={ 0}
            color={"yellow"}
            textAfter={isFetching}
            appealTotal={pendingStatus.category?.APPEAL || 0}
            suggestTotal={pendingStatus.category?.SUGGEST || 0} 
            feedbackTotal={pendingStatus.category?.FEEDBACK || 0}
          />
        </LoadingDashboard>
      </Col>
      <Col md={24} lg={8} xl={8}>
        <LoadingDashboard loading={isFetching}>
          <Box
            isGrid={true}
            title={t("number-completed-complaints")}
            count={ 0}
            color="green"
            textAfter={isFetching}
            appealTotal={successStatus.category?.APPEAL || 0}
            suggestTotal={successStatus.category?.SUGGEST || 0}
            feedbackTotal={successStatus.category?.FEEDBACK || 0}
          />
        </LoadingDashboard>
      </Col>
    </React.Fragment>
  );
};
